<div *ngIf="report && counts" class="report-container">
	<h2>{{report.name}}</h2>
	<div class="top-section">
		<div class="info">
			<div class="info-row"><span>Sent By&nbsp;</span><strong>{{report.agent.firstName}} {{report.agent.lastName}}</strong></div>
			<div class="info-row"><span>Created At&nbsp;</span><strong>{{report.createdAt | date:'yyyy-MM-dd HH:mm'}}</strong></div>
			<div class="info-row"><span>Sent At&nbsp;</span><strong>{{report.sentAt | date:'yyyy-MM-dd HH:mm'}}</strong></div>
		</div>

		<div class="info">
			<div class="info-row"><span>Channel(s)&nbsp;</span><strong>{{report.channel}}</strong></div>
			<div class="info-row"><span>Send Duration&nbsp;</span><strong>{{report.sendDuration ? (report.sendDuration / 1000) + 's' : '-'}}</strong></div>
			<div class="info-row"><span>Attachments&nbsp;</span>
				<button *ngIf="this.report.attachments.length > 0" nz-button nzType="default" (click)="downloadAttachments()">Download</button>
				<div *ngIf="this.report.attachments.length === 0"><strong>None</strong></div>
			</div>
		</div>

		<div class="right-stats">
			<h4>Deliveries</h4>
			<div class="stat-container">
				<div class="stat-box success">
					<h5>Success</h5>
					<div class="value">{{counts.success}} ({{counts.successPercentage}})</div>
				</div>
				<div class="stat-box failed">
					<h4>Failed</h4>
					<h6 class="value">{{counts.failed}} ({{counts.failedPercentage}})</h6>
				</div>
			</div>
		</div>
	</div>
	<div class="metric-info">
		<h4>Metrics</h4>
		<nz-tag *ngFor="let x of getPositiveMetrics()" nzColor="grey" class="rounded">{{x}}</nz-tag>
	</div>

	<div *ngIf="report.filters.length > 0" class="mt-3 mb-2 flex flex-wrap gap-2">
		<nz-tag
			*ngFor="let f of report.filters; let i = index"
			nzColor="blue">
			<ng-container *ngTemplateOutlet="filterTemplate; context: { $implicit: f }"></ng-container>
		</nz-tag>
	</div>

	<div class="content-wrapper">
		<div class="preview-box">
			<h3>{{report.subject}}</h3>
			<p>{{report.body}}</p>
		</div>
		<div class="delivery-metrics">
			<!-- <nz-card> -->
				<div class="metrics-wrapper">

					<div class="chart-container">
						<canvas #deliveryChart class="chart"></canvas>
					</div>

					<div class="metrics-info">
						<div class="metric">
							<div class="title">Delivery Rate</div>
							<div class="rate">{{counts.successPercentage}}</div>
						</div>
						<div class="metric">
							<div class="title">Failures</div>
							<div class="rate">{{counts.failedPercentage}}</div>
						</div>
					</div>

				</div>
			<!-- </nz-card> -->
		</div>
	</div>
	<form nz-form [formGroup]="searchForm" class="w-full">
		<nz-form-item class="w-full">
			<nz-form-label [nzTooltipTitle]="searchToolTip">Search</nz-form-label>
			<nz-form-control class="w-full">
				<nz-input-group [nzSuffix]="searchBtns">
					<input nz-input formControlName="search" placeholder="Search by Membership No, ID, or Name..." />
				</nz-input-group>
			</nz-form-control>
		</nz-form-item>

		<!-- Search & Clear buttons -->
		<ng-template #searchBtns>
			<button nz-button nzType="primary" (click)="doSearch()" nzSize="small">Search</button>
		</ng-template>

		<!-- Tooltip content -->
		<ng-template #searchToolTip>
			<ul class="m-0 p-0 list-disc list-inside">
				<li><b>Membership No.</b></li>
				<li>Member’s <b>ID Number</b></li>
				<li>Member’s <b>Surname, Names</b></li>
				<li *ngIf="report.channel === 'Email'">Member’s <b>Email Address</b></li>
				<li *ngIf="report.channel === 'Sms'">Member’s <b>Mobile No.</b></li>
			</ul>
		</ng-template>
	</form>
	<nz-table [nzData]="events" nzBordered>
		<thead>
			<tr>
				<th>Member Name</th>
				<th>Member Surname</th>
				<th>Member To</th>
				<th>Status</th>
				<th>Sent At</th>
				<th>Delivered At</th>
				<th *ngIf="report.channel === 'Email'">Opened At</th>
				<th *ngIf="report.channel === 'Email'">Delivery To Open</th>
				<th *ngIf="report.channel === 'Email'">Bounced At</th>
				<th *ngIf="report.channel === 'Sms'">Failed At</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let r of events">
				<td>{{ r.name }}</td>
				<td>{{ r.surname }}</td>
				<td>{{ r.to }}</td>
				<td>
					<nz-tag *ngIf="r.accepted > 0 && r.delivery === 0" nzColor="orange">
						{{ 'Accepted' }}
					</nz-tag>
					<nz-tag *ngIf="r.delivery > 0" nzColor="green">
						{{ 'Delivered' }}
					</nz-tag>
					<nz-tag *ngIf="report.channel === 'Email' && r.bounce > 0" nzColor="red">
						{{ 'Bounced' }}
					</nz-tag>
					<nz-tag *ngIf="report.channel === 'Sms' && r.bounce > 0" nzColor="red">
						{{ 'Failed' }}
					</nz-tag>
					<nz-tag *ngIf="report.channel === 'Email' &&  r.spamComplaint > 0" nzColor="pink">
						{{ 'Reported as Spam ' + r.spamComplaint + ' time(s)' }}
					</nz-tag>
					<nz-tag *ngIf="report.channel === 'Email' && r.open > 0" nzColor="blue">
						{{ 'Opened ' + r.open + ' time(s)' }}
					</nz-tag>
					<nz-tag *ngIf="report.channel === 'Email' &&  r.policyRejection > 0" nzColor="black">
						{{ 'Rejected' }}
					</nz-tag>
				</td>
				<td>{{ r.acceptedAt | date:'yyyy-MM-dd HH:mm' }}</td>
				<td>{{ r.deliveryAt | date:'yyyy-MM-dd HH:mm' }}</td>
				<td *ngIf="report.channel === 'Email'"><div *ngFor="let open of r.openedAt">{{open | date:'yyyy-MM-dd HH:mm'}}</div></td>
				<td *ngIf="report.channel === 'Email'">{{getDeliveryToOpenDuration(r)}}</td>
				<td>{{ r.bouncedAt | date:'yyyy-MM-dd HH:mm' }}</td>
			</tr>
		</tbody>
	</nz-table>
</div>
<ng-template #filterTemplate let-filter>
	<app-filter-info [filter]="filter"></app-filter-info>
</ng-template>